import type { PartyType } from '@/typings/detail'
import { t } from '@/plugins/i18n'

/** 地址类型常量 */
export const PARTY_TYPES = {
  /** 收货人 */
  CO: 'CO',
  /** 发货人 */
  SN: 'SN',
  /** 通知人 */
  NO: 'NO',
} as const

/** 地址类型标签映射 */
export const PARTY_TYPE_LABELS: Record<PartyType, string> = {
  CO: t('partyType.CO'),
  SN: t('partyType.SN'),
  NO: t('partyType.NO'),
}

/** 地址类型选项列表 */
export const PARTY_TYPE_OPTIONS = Object.entries(PARTY_TYPE_LABELS).map(
  ([value, label]) => ({
    value,
    label,
  }),
) as { value: PartyType; label: string }[]

export default PARTY_TYPES
